import React from "react";

import ASZFModel from "../components/aszf/aszf";

const ASZF = () => {
  return <ASZFModel />;
};

export default ASZF;
